export default __webpack_public_path__ + "static/media/UpsWarningBackgroundMobile.be48d40a.png";